<template>
  <el-main>
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item>供应商合同管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="" style="margin-left: -100px;">
          <el-col :span="5">
            <el-select v-model="form.atype" placeholder="请选择类别" style="margin-right: 0; width: 100%;">
              <el-option label="供应商合同编号" value="contract_no"></el-option>
              <el-option label="供应商名称" value="vendor"></el-option>
              <el-option label="供应商合同名称" value="contract_name"></el-option>
              <el-option label="客户公司名称" value="client_company"></el-option>
              <el-option label="品牌" value="brand"></el-option>
              <el-option label="客户项目名称" value="client_contract_name"></el-option>
              <el-option label="客户合同编号" value="client_contract_no"></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" style="margin-right: 10px;">
            <el-input placeholder="请输入内容" v-model="form.key" @keyup.enter.native="search" clearable @clear="search">
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-col>
        </el-form-item>

        <el-form-item label="更多：" prop="type">
          <el-col :span="5" style="margin-right: 20px;">
            <el-select v-model="form.status" placeholder="合同生效状态" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option label="未申请" value="4"></el-option>
              <el-option label="已申请" value="1"></el-option>
              <el-option label="已获取编号" value="2"></el-option>
              <el-option label="已盖章" value="3"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="已选条件">
          <el-tag v-for="tag in tags" :key="tag.key" effect="dark" closable @close="removeTag(tag)">
            {{ tag.key }}: {{ tag.value }}
          </el-tag>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div class="filter">
          <el-checkbox-group class="filtergroup" v-model="checkList" prop="checkList" :min="5">
            <el-checkbox label="合同编号"></el-checkbox>
            <el-checkbox label="客户公司名称"></el-checkbox>
            <el-checkbox label="品牌"></el-checkbox>
            <el-checkbox label="项目名称"></el-checkbox>
            <el-checkbox label="供应商合同编号"></el-checkbox>
            <el-checkbox label="供应商名称"></el-checkbox>
            <el-checkbox label="供应商合同名称"></el-checkbox>
            <el-checkbox label="供应商类型"></el-checkbox>
            <el-checkbox label="供应商合同金额"></el-checkbox>
            <el-checkbox label="已支付"></el-checkbox>
            <el-checkbox label="未支付"></el-checkbox>
            <el-checkbox label="已开票"></el-checkbox>
            <el-checkbox label="未开票"></el-checkbox>
            <el-checkbox label="已开票未支付"></el-checkbox>
            <el-checkbox label="供应商合同时间"></el-checkbox>
            <el-checkbox label="供应商合同状态"></el-checkbox>
            <el-checkbox label="项目负责人"></el-checkbox>
            <el-checkbox label="供应商合同类型"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="btnarea">
          <el-button icon="el-icon-plus" @click="link('/purchase/add?mType=1')" v-if="NodeInclude('99')">新增框架合同</el-button>
        </div>
      </div>

      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row>
        <el-table-column prop="contract_no" label="合同编号" header-align="center" align="center" min-width="150"
          v-if="check('合同编号')">
          <template slot-scope="scope">
            <div class="linkwrap normal">
              <el-link type='primary' class="link" @click="link(`/project/detail?id=${scope.row.projectArr.id}`)">{{ scope.row.projectArr.contract_no ? scope.row.projectArr.contract_no : '暂无' }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="client_company" label="客户公司名称" header-align="center" align="center" min-width="200"
          v-if="check('客户公司名称')">
          <template slot-scope="scope">
            {{ scope.row.projectArr.client_company ? scope.row.projectArr.client_company : '暂无' }}
          </template>
        </el-table-column>
        <el-table-column prop="brand" label="品牌" header-align="center" align="center" min-width="150" v-if="check('品牌')">
          <template slot-scope="scope">
            {{ scope.row.projectArr.brand ? scope.row.projectArr.brand : '暂无' }}
          </template>
        </el-table-column>
        <el-table-column prop="proje" label="项目名称" header-align="center" align="center" min-width="250"
          v-if="check('项目名称')">
          <template slot-scope="scope">
            {{ scope.row.projectArr.contract_name ? scope.row.projectArr.contract_name : '暂无' }}
          </template>
        </el-table-column>
        <el-table-column prop="contract_no" label="供应商合同编号" header-align="center" align="center" min-width="200"
          v-if="check('供应商合同编号')">
          <template slot-scope="scope">
            <div class="linkwrap normal">
              <el-link type='primary' class="link" @click="link(`/purchase/view?id=${scope.row.id}`)">{{ scope.row.contract_no }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="vendor" label="供应商名称" header-align="center" align="center" min-width="200"
          v-if="check('供应商名称')">
        </el-table-column>        
        <el-table-column prop="contract_name" label="供应商合同名称" header-align="center" align="center" min-width="400"
          v-if="check('供应商合同名称')" />
        <el-table-column prop="vendor_type" label="供应商类型" header-align="center" align="center" min-width="100"
          v-if="check('供应商类型')">
          <template slot-scope="scope">
            {{ dd.status2[scope.row.vendor_type] }}
          </template>
        </el-table-column>
        <el-table-column prop="contract_amount" label="供应商合同金额" header-align="center" align="right" min-width="120"
          v-if="check('供应商合同金额')">
          <template slot-scope="scope">
            {{ scope.row.contract_type == '2' ? '框架合同' : scope.row.contract_amount }}
          </template>
        </el-table-column>
        <el-table-column prop="totalPaidAmount" label="已支付" header-align="center" align="right" min-width="100"
          v-if="check('已支付')" />
        <el-table-column prop="totalNoPaidAmount" label="未支付" header-align="center" align="right" min-width="100"
          v-if="check('未支付')" />
        <el-table-column prop="totalInvoice" label="已开票" header-align="center" align="right" min-width="100"
          v-if="check('已开票')" />
        <el-table-column prop="totalUnInvoice" label="未开票" header-align="center" align="right" min-width="100"
          v-if="check('未开票')" />
        <el-table-column prop="totalInvoiceNoPaid" label="已开票未支付" header-align="center" align="right" min-width="100"
          v-if="check('已开票未支付')" />
        <el-table-column prop="time" label="供应商合同时间" header-align="center" align="center" min-width="200" v-if="check('供应商合同时间')">
          <template slot-scope="scope">
            {{ scope.row.contract_start_time }} - {{ scope.row.contract_end_time }}
          </template>
        </el-table-column> 
        <el-table-column prop="brandStr" label="供应商合同状态" header-align="center" align="center" min-width="120" v-if="check('供应商合同状态')">
          <template slot-scope="scope">
            <div class="circle-tag" :style="{'background': scope.row.status != '1' ? dd.pruchase_contract_status_c[scope.row.status].color : ((scope.row.is_apply == '1' ||scope.row.is_apply == '3') ? dd.pruchase_contract_status_c[4].color : dd.pruchase_contract_status_c[1].color)}">
              <div class="word">{{ scope.row.status != '1' ? dd.pruchase_contract_status_c[scope.row.status].word : ((scope.row.is_apply == '1' ||scope.row.is_apply == '3') ? dd.pruchase_contract_status_c[4].word : dd.pruchase_contract_status_c[1].word)}}</div>
            </div>
          </template> 
        </el-table-column>
        <el-table-column prop="realname" label="项目负责人" header-align="center" align="center" min-width="100"
          v-if="check('项目负责人')">
          <template slot-scope="scope">
            {{ scope.row.projectArr.manager_name ? scope.row.projectArr.manager_name : '暂无' }}
          </template>
        </el-table-column>
        <el-table-column prop="realname" label="供应商合同类型" header-align="center" align="center" min-width="120" v-if="check('供应商合同类型')">
          <template slot-scope="scope">
            {{ dd.contract_type[scope.row.contract_type] }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" width="80" align="center" fixed="right" v-if="NodeInclude('90') || NodeInclude('99') || NodeInclude('104')">
          <template slot-scope="scope">
            <div class="linkwrap">
              <el-link type='primary' class="link" @click="handleClick(scope.row)" v-if="(scope.row.bkUserArr.realname == realName || level == 1) && scope.row.contract_type == 2 && (NodeInclude('90') || NodeInclude('99'))">编辑</el-link>
              <el-link type='primary' class="link" @click="handleClick(scope.row)" v-if="scope.row.contract_type != 2 && ((NodeInclude('90') || NodeInclude('99')) || level == 1)">编辑</el-link>
              <el-link type='primary' class="link" @click="viewClick(scope.row)" v-if="NodeInclude('104')">查看</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="apage">
        <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
import { thousands } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'custom',
  data() {
    return {
      nodeLimtList: [],
      level: '',
      realName: '',
      checkList: [
        '合同编号',
        '客户公司名称',
        '品牌',
        '项目名称',
        '供应商合同编号',
        '供应商名称',
        '供应商合同名称',
        '供应商类型',
        '供应商合同金额',
        '已支付',
        '未支付',
        '已开票',
        '未开票',
        '已开票未支付',
        '供应商合同时间',
        '供应商合同状态',
        '项目负责人',
        '供应商合同类型',
      ],
      itemList: [],
      total: 0,
      perPage: 30,
      p: 1,
      statusData: [],
      form: {
        key: '',
        atype: 'contract_name',
        status: '',
      },
    }
  },
  computed: {
    tags() {
      let temp = [
        {
          key: this.dd.pruchaseType[this.form.atype],
          val: 'atype',
          value: this.form.key,
          active: !!this.form.atype && !!this.form.key,
        },
        {
          key: '合同生效状态',
          val: 'status',
          value: this.dd.pruchase_contract_status[this.form.status],
          active: !!this.form.status,
        },
      ]
      temp = temp.filter((item) => item.active)
      return temp
    },
  },
  created() {
    this.statusData = this.$utils.objToOptions(this.$config.statusDataCard)
  },
  mounted() {
    this.getStoreFn()
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    link(url) {
      this.$router.push(url)
    },
    check(key) {
      return this.checkList.includes(key)
    },
    handleClick(item) {
      console.log(item)
      this.$router.push({
        path: '/purchase/add',
        query: { id: item.id, kind: item.contract_type != '2' ? '1' : '', mType: item.project_type },
      })
    },
    viewClick(item) {
      console.log(item)
      this.$router.push({
        path: '/purchase/view',
        query: { id: item.id, mType: item.project_type },
      })
    },

    search() {
      this.p = 1
      store.commit('setPurData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },

    getStoreFn() {
      this.form = Object.keys(store.state.purData).length != 0 ? store.state.purData : this.form
      this.getList()
    },

    getList() {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const postData = {
        ...this.form,
        p: this.p,
        [this.form.atype]: this.form.key,//搜索
      }
      api.getContractList(postData).then((res) => {
        this.itemList = res.itemList
        this.itemList = this.itemList.map((item) => {
          item.totalPaidAmount = thousands(Number(item.totalPaidAmount))
          item.totalNoPaidAmount = thousands(Number(item.totalNoPaidAmount))
          item.totalInvoice = thousands(Number(item.totalInvoice))
          item.totalUnInvoice = thousands(Number(item.totalUnInvoice))
          item.totalInvoiceNoPaid = thousands(Number(item.totalInvoiceNoPaid))
          item.contract_amount = thousands(Number(item.contract_amount))
          return item
        })
        this.total = +res.totalNum
        setTimeout(() => {
          //权限
          this.level = store.state.level   
          this.realName = store.state.realName    
        }, 200);
      })
    },
    removeTag(tag) {
      !{
        type: () => {
          this.form['key'] = undefined
        },
      }[tag.val]?.()
      this.form[tag.val] = ''
      this.form.key = this.form.atype == '' ? '' : this.form.key 
      store.commit('setPurData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
      console.log(tag)
    },
    handleCurrentChange(p) {
      this.p = p
      store.commit('setPurData', JSON.parse(JSON.stringify(this.form)))
      this.getList()  
    },
  },
}
</script>

<style lang="scss" scoped>
.filterwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 20px 0;
  .filter {
    width: 85%;
  }
  .btnarea {
    box-sizing: border-box;
    width: 15%;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.el-checkbox-group.filtergroup .el-checkbox {
  width: auto;
}

.apage {
  background: #f2f2f2;
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.table {
  @extend %box;
  padding: 30px;
}

.linkwrap {
  font-size: 12px;
  &.normal {
    color: #606266;
    a {
      color: #606266;
      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }
      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}
</style>
